export const props = {
  /*
		route path for testing purposes
	*/
  _testAmenityID: {
    type: Number,
    default: undefined
  }
}
